type Props = {
  children: React.ReactNode
}

function WrapperStyled({ children }: Props) {
  return (
    <div className="flex flex-col items-center w-full p-5 gap-10 pb-20 text-text-secondary bg-background-dark lg:p-10 lg:pb-20 lg:flex-grow bg-foreground text-primary-foreground">
      {children}
    </div>
  )
}

export { WrapperStyled }
